module.exports = __webpack_public_path__ + "img/邮件.f464ab28.png";